var Modernizr;

Modernizr = require('../vendor_modules/modernizr');

if (Modernizr.touchevents !== void 0) {
  Modernizr.touchevents = Modernizr.touchevents.valueOf() || !!window.navigator.maxTouchPoints;
  Modernizr.touch = Modernizr.touchevents;
  document.documentElement.className += Modernizr.touchevents ? ' touch' : ' no-touch';
}

Modernizr.addTest('csspseudoanimations', function() {
  var result, styles;
  result = false;
  if (!(Modernizr.cssanimations && window.getComputedStyle)) {
    return result;
  }
  styles = ['@', Modernizr._prefixes.join('keyframes csspseudoanimations { from { font-size: 10px; } }@').replace(/@$/, ''), '#modernizr:before { content:" "; font-size:5px;', Modernizr._prefixes.join('animation:csspseudoanimations 1ms infinite;'), '}'].join('');
  Modernizr.testStyles(styles, function(elem) {
    var style;
    style = window.getComputedStyle(elem, ':before');
    if (style !== null) {
      return result = style.getPropertyValue('font-size') === '10px';
    }
  });
  return result;
});

